import { render, staticRenderFns } from "./returns.vue?vue&type=template&id=ed705338"
import script from "./returns.vue?vue&type=script&lang=js"
export * from "./returns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports